import { useEffect, useMemo, useState } from 'react';

import { EStickyType } from './constants';

export interface IUseStickyProps {
  onTopStuck?: (isIntersecting: boolean) => void;
  onBottomStuck?: (isIntersecting: boolean) => void;
  topOffset?: number | string;
  bottomOffset?: number | string;
}

export const useStickyProps = (props: IUseStickyProps) => {
  const { onBottomStuck, onTopStuck, topOffset, bottomOffset } = props;
  const bottom = useMemo(() => (bottomOffset || onBottomStuck ? 0 : undefined), [bottomOffset, onBottomStuck]);
  const top = useMemo(() => (topOffset || onTopStuck ? 0 : undefined), [topOffset, onTopStuck]);

  const [stickyType, setStickyType] = useState<EStickyType>(EStickyType.Simple);

  useEffect(() => {
    switch (true) {
      case !(onBottomStuck || onTopStuck):
        return setStickyType(EStickyType.Simple);
      case 'IntersectionObserver' in window:
        return setStickyType(EStickyType.Modern);
      default:
        return setStickyType(EStickyType.Old);
    }
  }, [onBottomStuck, onTopStuck]);

  return { bottom, top, stickyType };
};
